import { CosmeticSource } from '@profile/src/models';
export const options = [{
  label: 'Open Box',
  id: CosmeticSource.OPEN_BOX
}, {
  label: 'Sold',
  id: CosmeticSource.SOLD
}, {
  label: 'Purchase',
  id: CosmeticSource.PURCHASE
}, {
  label: 'Ranking Reward',
  id: CosmeticSource.RANKING_REWARD
}, {
  label: 'Mint',
  id: CosmeticSource.SEASON_END
}, {
  label: 'Season End',
  id: CosmeticSource.MINT
}];